import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UtilizationState } from './utilization.reducer';

export const getUtilization = createFeatureSelector<UtilizationState>('utilization');

export const getUtilizationProfiles = createSelector(
  getUtilization,
  (state: UtilizationState) => state?.utilizationProfiles || []
);

export const getSelectedUtilizationProfile = createSelector(getUtilization, (state: UtilizationState) =>
  state.utilizationProfiles.find(profile => profile.profileId === state?.selectedUtilizationProfile)
);

export const getMcInstances = createSelector(
  getUtilization,
  (state: UtilizationState) => state.profileDialogState?.mcInstances || []
);

export const getMCGroups = createSelector(
  getUtilization,
  (state: UtilizationState) => state.profileDialogState?.mcInstanceGroups || []
);

export const getStores = createSelector(
  getUtilization,
  (state: UtilizationState) => state.stores || []
);

export const editUtilizationProfile = createSelector(
  getUtilization,
  (state: UtilizationState) => state.editUtilizationProfile
);

export const getWallMappings = createSelector(getUtilization, (state: UtilizationState) => state.wallMappings);

export const getCustomAttributes = createSelector(getUtilization, (state: UtilizationState) => state.customAttributes);

export const getUtilizationConfig = createSelector(getUtilization, (state: UtilizationState) => state.config);
